import { Box, Typography } from "@mui/material";
import { baseTheme } from "../../../themes/shipinsure";

export function ShippingAddressCard({ address, t }) {
  if (!address) {
    return null;
  }

  const lines = [
    address.name,
    address.street_address_1,
    address.street_address_2,
    [address.city, address.state_or_province, address.postal_code]
      .filter(Boolean)
      .join(", "),
    address.country,
  ].filter(Boolean);

  return (
    <Box
      mb="24px"
      sx={{
        border: "1px solid #E2E8F0",
        borderRadius: "16px",
        padding: "20px",
      }}
    >
      <Typography variant="h6" mb="12px">
        {t("status.shippingAddress")}
      </Typography>
      {lines.map((line) => (
        <Typography key={line} color={baseTheme.colors.textLight}>
          {line}
        </Typography>
      ))}
    </Box>
  );
}
